import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import styled from "@emotion/styled/macro";
import { withProps } from "recompose";
import { useTranslation } from "react-i18next";
import bullet from "../../../assets/images/bullet.svg";
import { filterMenuBasedOnCms } from "../../../helpers/helpers";

const MenuItem = styled.li`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0 ${({ theme }) => theme.layout.header.menu.spacing}
  };
  
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.primary};
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    & .selected {
      color: ${({ theme }) => theme.colors.opal};
      img {
        visibility: visible;
      }
    }
  }
  a {
    user-select: none;
    outline: none;
  }
}
`;
const Bullet = withProps({ src: bullet })(styled.img`
  visibility: hidden;
  margin-left: auto;
  margin-right: auto;
`);

export const menuItems = [
  { link: "/check", label: "header.menu.checker" },
  { link: "/abroad", label: "header.menu.abroad", cmsId: "abroad" },
  { link: "/accident", label: "header.menu.accident", cmsId: "accident" },
  { link: "/verification", label: "header.menu.verification", cmsId: "access" },
];

const Menu = ({ onClose }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const [filteredMenu, setFilteredMenu] = useState();

  useEffect(() => {
    const filterMenu = async () => {
      const result = await filterMenuBasedOnCms(menuItems, language);
      setFilteredMenu(result);
    };
    filterMenu(); // eslint-disable-next-line
  }, []);

  return (
    <ul>
      {filteredMenu?.map((item, key) => (
        <MenuItem key={key}>
          <NavLink to={item.link} activeClassName="selected" onClick={onClose}>
            {t(item.label)}
            <Bullet />
          </NavLink>
        </MenuItem>
      ))}
    </ul>
  );
};

export default Menu;
